import * as React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../';
import Loader from '../Loader/Loader';

declare var process: any;

interface Props {
  services: IService[];
  loading?: boolean;
}

export default ({ services, loading }: Props) => (
  <Card list>
    {!loading ? (
      <table>
        <thead>
          <tr>
            <th>Vehicle</th>
            <th>Mileage</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {services.map((service) => (
            <tr key={service.id}>
              <td>
                <div className="media">
                  <figure className="media-left">
                    <span className="avatar image is-32x32">
                      <img
                        src={`${process.env.API_URL}/vehicles/types/${
                          service.vehicle.vehicle_type.id
                        }/image`}
                      />
                    </span>
                  </figure>
                  <div className="media-content">
                    <Link to={`/settings/vehicles/${service.vehicle.id}`}>
                      {service.vehicle.registration}
                    </Link>
                    <br />
                    <small>{service.vehicle.vehicle_type.name}</small>
                  </div>
                </div>
              </td>
              <td>{service.mileage}</td>
              <td>
                {service.type
                  .replace('_', ' ')
                  .toLowerCase()
                  .replace(/\b(\w)/g, (c) => c.toUpperCase())}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <Loader fullwidth />
    )}
  </Card>
);
